<template>
	<div>
		<div class="h4 mb-3">Sign Up</div>
		<b-form @submit.prevent="create(email.toLowerCase(), password, confirmPassword, recaptchaToken)">
			<b-form-group id="input-group-1">
				<b-input id="inline-form-input-name" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Email" v-model="email"></b-input>
			</b-form-group>

			<b-form-group id="input-group-1">
				<b-input id="inline-form-input-username" placeholder="Password" type="password" v-model="password"></b-input>
			</b-form-group>

			<b-form-group id="input-group-1">
				<b-input id="inline-form-input-username" placeholder="Repeat Password" type="password" v-model="confirmPassword"></b-input>
			</b-form-group>
			<b-form-group>
				<vue-recaptcha ref="recaptcha" sitekey="6Le1os0ZAAAAADP7LqF8yoLDRbZPp-Pjqjg9kifI" :loadRecaptchaScript="true" size="large" @verify="checkRecaptcha" class="captcha"></vue-recaptcha>
			</b-form-group>
			<b-form-group id="input-group-4">
				<b-button class="w-100" variant="primary" type="submit" :disabled="!verified">Sign Up</b-button>
			</b-form-group>
		</b-form>
		<div class="alert alert-danger" role="alert" v-if="registerError">
			<strong>Whoops!</strong> {{ registerError }}
		</div>
		<div class="small">Already have an account? <router-link to="/sign-in" class="text-primary" style="text-decoration: underline;">Sign In</router-link></div>
	</div>
</template>

<script>
	import VueRecaptcha from 'vue-recaptcha';
	export default {
		name: 'SignUp',
		components: {
			VueRecaptcha
		},
		data () {
			return {
				email: '',
				password: '',
				confirmPassword: '',
				registerError: false,
				verified: false,
				recaptchaToken: ''
			};
		},
		methods: {
			checkRecaptcha (token) {
				this.verified = true;
				this.recaptchaToken = token;
			},
			create (email, password, confirmPassword, recaptchaToken) {
				this.registerError = false;
				if (email.length < 5) {
					this.registerError = 'Please enter a valid email!';
					return false;
				}
				if (password.length < 8) {
					this.registerError = 'Please enter a password longer than 8 characters!';
					return false;
				}
				if (password !== confirmPassword) {
					this.registerError = 'Your passwords do not match!';
					return false;
				}
				const {
					User
				} = this.$FeathersVuex.api
				new User({
					email,
					password,
					recaptchaToken
				})
				.save()
				.then(() => {
					this.$store.dispatch('auth/authenticate', {
							strategy: 'local',
							email,
							password
						})
						.then(() => {
							this.$router.push('/');
						});
				})
				// Just use the returned error instead of mapping it from the store.
				.catch(err => {
					this.$refs.recaptcha.reset();
					this.verified = false;
					// Convert the error to a plain object and add a message.
					if (err.data ) {
						let type = err.data.code;
						err = Object.assign({}, err);
						err.message =
							type === 11000 ?
							'That email address is unavailable.' :
							'An error prevented signup.'
					}
					this.registerError = err.message;
				});
			}
		}
	}
</script>

<style lang="scss">
	.captcha {
		width: 304px;
		margin: 0 auto;
	}
</style>
